import { put, call, takeLatest, delay } from 'redux-saga/effects';
import axios from 'axios';
import config from '../config';
import Cookies from 'js-cookie';

//Action
import { loadingSet } from '../action/uiAction';

var packageJson = require('../../package.json');

function* communityQaListGet(action) {
  yield put(loadingSet(true));

  let page = (action.payload.page) ? action.payload.page : 1;

  const {res, err} = yield call( function(payload) {
    var params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('page', page);
    params.append('version', packageJson.version);
    return axios.post(config.apiUri + "member/communityQaListApi.php", params, {
      timeout: 10000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  yield delay(100);
  if (res) {
    if (res.data.bool) {
      yield put({
        type: "COMMUNITY_QA_LIST_SET",
        payload: {
          list: res.data.list,
          page: page,
          isList: res.data.isList,
          isListNext: res.data.isListNext,
        },
      });
    }
    if (err) {
      yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
    }
  }
  yield put(loadingSet(false));
}





function* communityQaStatisticsGet(action) {
  yield put(loadingSet(true));

  const {res, err} = yield call( function(payload) {
    var params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('qaId', payload.qaId);
    return axios.post(config.apiUri + "member/communityQaStatisticsApi.php", params, {
      timeout: 5000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);

  if (res) {
    if (res.data.bool) {
      yield put({
        type: "COMMUNITY_QA_STATISTICS_SET",
        payload: {
          type: 'add',
          qaId: action.payload.qaId,
          statistics: res.data.statistics,
        },
      });
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}

function* communityQaStatisticsUserGet(action) {
  yield put(loadingSet(true));

  const {res, err} = yield call( function(payload) {
    var params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('qaId', payload.qaId);
    params.append('answerText', payload.answerText);
    params.append('page', payload.page);
    return axios.post(config.apiUri + "member/communityQaStatisticsUserApi.php", params, {
      timeout: 5000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);

  if (res) {
    if (res.data.bool) {
      action.callback(res.data);
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}


const saga = [
  takeLatest('COMMUNITY_QA_LIST_GET', communityQaListGet),
  takeLatest('COMMUNITY_QA_STATISTICS_GET', communityQaStatisticsGet),
  takeLatest('COMMUNITY_QA_STATISTICS_USER_GET', communityQaStatisticsUserGet),
];

export default saga;
